import React from "react";
import { ReactComponent as ImagemMenuBack } from "../assets/images/icons/menu-back.svg";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface PaginaTituloProps extends RouteComponentProps {
  link?: string,
  titulo: string,
  subtitulo?: string,
  subtituloClick?: any,
};

class PaginaTitulo extends React.Component<PaginaTituloProps, {}> {

  navigateUrl(url?: string): void {
    if (url && url.length > 0) {
      this.props.history.push(url);
    } else {
      this.props.history.goBack();
    }
  }

  render (): any {
    let { link, titulo, subtitulo, subtituloClick } = this.props;

    return (
      <div className="current-search">
        <div className="back" onClick={ () => this.navigateUrl(link) } >
          <ImagemMenuBack />
        </div>
        <div>
          <p dangerouslySetInnerHTML={{ __html: titulo }}></p>
          {subtitulo !== null &&
          <p className="second" onClick={ () => { return subtituloClick ? subtituloClick() : ""; }} dangerouslySetInnerHTML={{ __html: subtitulo ? subtitulo : "" }}></p>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(PaginaTitulo);